/**
 * Converts an ISO 8601 date string to YYYY-MM-DD format
 * @param isoDate - ISO 8601 formatted date string (e.g., "2026-01-27T06:37:43.197Z")
 * @returns Date string in YYYY-MM-DD format (e.g., "2026-01-27") or null if invalid
 */
export const formatISOToDisplayDate = (isoDate: string | Date | null | undefined): string | null => {
  if (!isoDate) {
    return null;
  }

  try {
    let dateObj: Date;

    // If it's already a Date object, use it directly
    if (isoDate instanceof Date) {
      dateObj = isoDate;
    } else if (typeof isoDate === 'string') {
      dateObj = new Date(isoDate);
    } else {
      return null;
    }

    // Check if the date is valid
    if (isNaN(dateObj.getTime())) {
      console.warn('Invalid ISO date format:', isoDate);
      return null;
    }

    // Extract the date components in UTC to avoid timezone issues
    const year = dateObj.getUTCFullYear();
    const month = String(dateObj.getUTCMonth() + 1).padStart(2, '0');
    const day = String(dateObj.getUTCDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  } catch (error) {
    console.error('Error converting ISO date to display format:', error);
    return null;
  }
};

export default formatISOToDisplayDate;
